<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Menu" subTitle="Forms" />

    <ListMenu />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListMenu from "@/components/Pages/Master/Menu/ListMenu.vue";

export default defineComponent({
  name: "ListMenuPage",
  components: {
    PageTitle,
    ListMenu,
  },
});
</script>
